import { useState, useEffect, createContext, useContext, useCallback } from "react";
import translations from "../constants/translations";

const LanguageContext = createContext(null);

const useLanguage = () => useContext(LanguageContext);

const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    return localStorage.getItem("duofit-lang") || "pl";
  });

  const setLang = useCallback((newLang) => {
    setLangState(newLang);
    localStorage.setItem("duofit-lang", newLang);
  }, []);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations["pl"]?.[key] || key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export { LanguageContext, LanguageProvider, useLanguage };
